import { useContext } from "react";
import { SidebarContext } from "../providers/SidebarProvider";

export const useSidebar = () => {
    return useContext(SidebarContext);
}